import { request } from '@/utils/api-request'
import axios from 'axios'

const solomonUrl = process.env.VUE_APP_SOLOMON_BASE_URL || "https://staging-solomon-api.beusable.net"

export function getEmailList (params) {
  const url = '/admin/email/email_list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getEmail (params) {
  const url = '/admin/email/get_email'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function emailResend (params) {
  const url = '/admin/email/email_resend'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getContactUsHistoryList(params) {
  const url = "/admin/contactus/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getContactUsHistoryDetail(params) {
  const url = "/admin/contactus/detail";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function updateContactusHistory(params) {
  const url = "/admin/contactus/update";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}


export function getInboxList(params) {
  const url = '/admin/inbox/inbox_list'
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true)
}

export function getInbox (params) {
  const url = '/admin/inbox/get_inbox'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function sendInboxReply(params) {
  const url = "/admin/inbox/send_mail"
  const config = {
    method: "post",
    url,
    data: params
  };
  return request(config, true)
}

export const getInboxReply = async (data) => {
  let accessToken = localStorage.getItem('solomon_accessToken')

  if (!accessToken) {
    await connect()
    accessToken = localStorage.getItem('solomon_accessToken')
  }

  const config = {
    headers: { Authorization: `Bearer ${accessToken}` }
  }

  return axios
    .post(`${solomonUrl}/question/ask`, data, config)
    .then((res) => res.data)
    .catch(async (e) => {
      if (e.response.status === 401) {
        await refresh()
      }
    })
}

export async function connect() {
  const accessToken = localStorage.getItem(`solomon_accessToken`)
  const headers = {
    headers: {
      Authorization: accessToken && `Bearer ${accessToken}`,
    },
    withCredentials: true
  }

  return axios
      .get(`${solomonUrl}/hello`, headers)
      .then((res) => {
        const accessToken = res.data.access_token
        const refreshToken = res.data.refresh_token
        if (accessToken) localStorage.setItem(`solomon_accessToken`, accessToken)
        if (refreshToken) localStorage.setItem(`solomon_refreshToken`, refreshToken)
      })
      .catch((e) => {
        console.log('e', e)
      })
}

export async function refresh() {
  const headers = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(`solomon_refreshToken`)}`
    },
    withCredentials: true
  }

  return axios
    .get(`${solomonUrl}/refresh`, headers)
    .then((res) => {
      const accessToken = res.data.access_token
      localStorage.setItem(`solomon_accessToken`, accessToken)
    })
    .catch((e) => {
      if (e.response.status === 401) {
        localStorage.removeItem(`solomon_accessToken`)
        localStorage.removeItem(`solomon_refreshToken`)
        console.error('솔로몬 세션이 만료되었습니다. 다시 시도해주세요.')
      }
    })
}